export default "/_next/static/images/f1bd53a8c246686ea915605ced7c3b3a.jpg";